import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "#2D6470",
        d: "M25 10.71v9.607a1.92 1.92 0 0 1-1.918 1.921h-9.611c-.874 0-2.014-.47-2.635-1.091l-4.274-4.274a1.92 1.92 0 0 1 0-2.715l4.274-4.275c.621-.62 1.758-1.091 2.635-1.091h9.611c1.06 0 1.918.858 1.918 1.917"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        "fill-rule": "nonzero",
        d: "M21.153 12.02a.67.67 0 0 1 0 .948l-2.368 2.368 2.368 2.369a.67.67 0 1 1-.947.947l-2.368-2.37-2.369 2.37a.67.67 0 1 1-.947-.947l2.369-2.37-2.369-2.367a.67.67 0 1 1 .947-.947l2.369 2.368 2.368-2.368a.67.67 0 0 1 .947 0"
      })
    ], -1)
  ]))]))
}
export default { render: render }